module.exports = __webpack_public_path__ + "img/18600.4beb7ff6.jpg";